import { render, staticRenderFns } from "./RedIcon.vue?vue&type=template&id=2ed18a0b&scoped=true"
import script from "./RedIcon.vue?vue&type=script&lang=js"
export * from "./RedIcon.vue?vue&type=script&lang=js"
import style0 from "./RedIcon.vue?vue&type=style&index=0&id=2ed18a0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed18a0b",
  null
  
)

export default component.exports